export const roles = {
  hybridConsultant: "HYBRID_CONSULTANT",
  consultant: "CONSULTANT",
  vendor: "VENDOR",
  client: "CLIENT",
};

export const userPermissions = {
  job:{
    add: 'add-job',
    view: 'view-job',
    edit: 'edit-job', 
    vendorAction: 'assign-vendors',
    clientAction: 'change-client',
    consultantAction: 'assign-consultants',
    timesheetAction: 'approve-reject-timesheet',
    invoiceAction: 'pay-invoice'
  },
  invoices:{
    add: 'add-invoice',
    view: 'view-invoice',
    invoiceAction: 'discard-invoice'
  },
  timesheet:{
    add: 'add-timesheet',
    view: 'view-timesheet',
    edit: 'edit-timesheet',
    submit: 'submit-timesheet'
  },
  myAccount:{
    view: 'view-account',
    edit: 'edit-account'
  },
  settings:{
    edit: 'edit-settings'
  },
  clientConnection:{
    add: 'add-client-connection',
    view: 'view-client-connection'
  },
  vendorConnection:{
    add: 'add-vendor-connection',
    view: 'view-vendor-connection'
  },
  consultantConnection:{
    add: 'add-consultant-connection',
    view: 'view-consultant-connection'
  },
}
export const s3Url = process.env.REACT_APP_S3_URL;

export const timesheetStatus = {
  none: "NONE",
  saved: "SAVED",
  submitted: "SUBMITTED",
  approved: "APPROVED",
  rejected: "REJECTED",
};

export const InvoiceStatusLabel = {
  DRAFT: { label: "Saved", color: "#E5C51C", bgColor: "#E5C51C33" },
  SUBMITTED: { label: "Submitted", color: "#E5C51C", bgColor: "#E5C51C33" },
  APPROVED: { label: "Approved", color: "#139588", bgColor: "#13958833" },
  PAID: { label: "Paid", color: "#139588", bgColor: "#13958833" },
};
export const consultantAvailability = [
  {
    value: "AVAILABLE",
    label: "Available",
  },
  {
    value: "PARTIAL",
    label: "Partialy Available",
  },
  {
    value: "NOTAVAILABLE",
    label: "Not Available",
  },
];
